import storage from 'helpers/storage';
import request from './api';

function logout() {
  storage.clearAppStorage();
}

function login(email, password) {
  return request({
    url: '/login',
    method: 'POST',
    data: {
      email,
      password,
    },
  });
}

function verifyOtp(body, csrfToken) {
  return request({
    url: '/otp/verify',
    method: 'POST',
    data: body,
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
  });
}

function getCurrentUser(token) {
  return request({
    url: '/user',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function register(body) {
  return request({
    url: '/register',
    method: 'POST',
    data: body,
  });
}

function verifyHash(params) {
  return request({
    url: '/register/is-valid',
    method: 'GET',
    params,
  });
}

function mailStatus(params) {
  return request({
    url: '/register/mailStatus',
    method: 'GET',
    params,
  });
}

function setPassword(params) {
  return request({
    url: '/register/set-password',
    method: 'GET',
    params,
  });
}

function changePassword(params) {
  return request({
    url: '/register/change-password',
    method: 'GET',
    params,
  });
}
function sendSupport(body) {
  return request({
    url: '/support',
    method: 'POST',
    data: body,
  });
}

function resetPassword(email) {
  return request({
    url: `/register/email/${email}/password-reset`,
    method: 'GET',
  });
}

function getCaptcha(body) {
  return request({
    url: '/captcha/get',
    method: 'POST',
    data: body,
  });
}

function checkCaptcha(body) {
  return request({
    url: '/captcha/check',
    method: 'POST',
    data: body,
  });
}

const auth = {
  login,
  sendSupport,
  getCurrentUser,
  register,
  verifyHash,
  mailStatus,
  setPassword,
  changePassword,
  resetPassword,
  logout,
  getCaptcha,
  checkCaptcha,
  verifyOtp,
};

export default auth;
